// The kinds of programme: a term (weekly before / after school), a holiday programme, and a special day (a one-off such as a teacher-only day).
// Holiday programmes and special days are both made of whole days, so they share their sessions, fees and day-by-day planning.
export const KIND_LABEL = { term: "Term programme", holiday: "Holiday programme", special: "Special day" };
export const KIND_SHORT = { term: "term", holiday: "holiday", special: "special day" };
export const isDayProgramme = (kind) => kind === "holiday" || kind === "special";
export const kindLabel = (kind) => KIND_LABEL[kind] || KIND_LABEL.term;
export const kindShort = (kind) => KIND_SHORT[kind] || KIND_SHORT.term;
